import {IVehicleRegistrationNumber} from '../interfaces/interfaces';

export class VehicleRegistrationNumber implements IVehicleRegistrationNumber {

    static empty() {
        return new VehicleRegistrationNumber('');
    }

    constructor(private vehicleRegistration: string) {

    }

    get value() {
        return this.vehicleRegistration;
    }

    isEmpty() {
        return (this.value === '');
    }

    toString() {
        return this.value;
    }
}



// WEBPACK FOOTER //
// ./app/types/VehicleRegistrationNumber.ts